// src/lib/stripePublic.ts
import { loadStripe, Stripe } from '@stripe/stripe-js';

const PK = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';
const STRIPE_LOAD_OPTIONS = {
  developerTools: {
    assistant: {
      enabled: false,
    },
  },
} as const;

export const stripePromise: Promise<Stripe | null> | null = PK
  ? loadStripe(PK, STRIPE_LOAD_OPTIONS)
  : null;

if (!PK) {
  // eslint-disable-next-line no-console
  console.warn('[stripe] Missing REACT_APP_STRIPE_PUBLISHABLE_KEY. Stripe Elements will be disabled.');
}
